<!--
  實例:
  <hk-radio v-model="value" label="1">Individual</hk-radio>
-->
<template>
  <div style="line-height: 0.3rem;margin-right: 0.4rem; max-width:1.7rem;display:inline-block;" class="ms-checkBox">
    <div class="hk-checkbox" :aria-labelledby="ariaLabelledby">
      <span @keydown="keydown">
        <!-- <span class="checkbox-label" :class="both?'active':(value == label && value != '' ? 'active': '')" tabindex="0"></span> -->
        <!-- <span class="checkbox-label" :class="(countEmail%2 == 1 && checkVaule =='EMAIL')  || (countPost%2 == 1 && checkVaule =='POST')?'active':''" tabindex="0"></span> -->
      <input type="checkbox" @click="clickCheckBox(label)" :id="groupName+checkValue" :checked="countEmail%2 == 1   ||countPost%2 == 1" :class="countEmail%2 == 1   ||countPost%2 == 1 ?'active':''" tabindex="0" role="checkbox" class="checkbox-label" :title="title"  :alt="title" :aria-describedby="ariaDescribedby" :aria-labelledby="title" :name="groupName"/>
        <label :for="groupName+checkValue">
          <slot></slot>
        </label>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    ariaDescribedby: {
      type: String,
      default: ''
    },
    ariaLabelledby: {
      type: String,
      default: ''
    },
    role: {
      type: String,
      default: ''
    },
    groupName: {
      type: String,
      default: ''
    },
    checkValue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectVal: '',
      countEmail:0,
      countPost:0,
      list:[],
      checkVaule:''
    }
  },
  methods: {
    changeValue(val,lab) {
        console.log(this.countPost)
        console.log(this.countEmail)
        console.log(val+"------------------------");
        console.log(lab + '-----------------')
         this.selectVal = val;
        //  this.label = val;
         if(val=='POST' && lab == 'POST') {
           console.log("POST")
            this.countPost = 1;
            this.countEmail = 0;
          } else if(val=='POST' && lab == 'EMAIL') {
           console.log("POST")
            this.countPost = 0;
            this.countEmail = 0;
          } else if(val=='EMAIL' && lab == 'EMAIL') {
             console.log("EMAIL")
            this.countPost = 0;
            this.countEmail = 1;
            
          }  else if(val=='EMAIL' && lab == 'POST') {
             console.log("EMAIL")
            this.countPost = 0;
            this.countEmail = 0;
            
          } else if(val=='BOTH') {
            this.countPost = 1;
            this.countEmail = 1;
          } else if(val == '') {
            this.countPost = 0;
            this.countEmail = 0;
          }

          this.$emit('input', this.selectVal)
          this.$emit('change', this.selectVal)
          console.log(this.countPost)
          console.log(this.countEmail)
    },
    click () {
      console.log(this.countEmail);
      console.log(this.countPost);
      console.log(this.selectVal);
      console.log("value"+this.value)
      console.log("label"+this.label)
      if(this.label == 'POST'){
        this.selectVal = this.label
        this.countPost = this.countPost + 1 ;
        this.countEmail = 0;
        // this.checkVaule ='POST';
        // console.log(this.checkVaule =='POST');
        // console.log( this.countPost)
        // console.log(this.countPost%2 == 1 && this.checkVaule =='POST')

        if(this.countPost%2 == 1){
          this.$emit('input', this.selectVal)
          this.$emit('change', this.selectVal)
        //   this.list.push(this.selectVal)
        } else{
            console.log("quxiao")
          
            this.$emit('input', '')
            this.$emit('change', '')
         
          
        }
        
        
      } else if(this.label == 'EMAIL' ) {
        this.selectVal = this.label
        this.countEmail = this.countEmail + 1;
        this.countPost = 0;
        // this.checkVaule ='EMAIL'
        // console.log(this.checkVaule =='EMAIL');
        // console.log(this.countEmail%2 == 1 && this.checkVaule =='EMAIL')
        if(this.countEmail%2 == 1){
          this.$emit('input', this.selectVal)
          this.$emit('change', this.selectVal)
       }  else{
            console.log("quxiao")
          
            this.$emit('input', '')
            this.$emit('change', '')
         
          
        }
      }
      // if(!this.value||(this.value == 'INDIVIDUAL'&&this.label == 'CORPORATE')||(this.value == 'CORPORATE'&&this.label == 'INDIVIDUAL')){
      //   console.log('123')
      //   this.selectVal = this.label
      //   this.both = true;
      //   this.$emit('input', this.selectVal)
      //   this.$emit('change', this.selectVal)
      // }else{console.log(456);
      //   this.both = false;
      //   this.$emit('input', '')
      //   this.$emit('change', '')
      // }
      // if(this.value){
      //   console.log(444);
      //   this.both = false;
      //   this.$emit('input', '')
      //   this.$emit('change', '')
      // }

      // if(this.value == '1') {
      //   this.$emit('input', '')
      //   this.$emit('change', '')
      // }
      
    },
    clickCheckBox (label) {
      console.log(this.countEmail);
      console.log(this.countPost);
      console.log(this.selectVal);
      console.log("value"+this.value)
      console.log("label"+label)
      if(label == 'POST'){
        this.selectVal = label
        this.countPost = this.countPost + 1 ;
        this.countEmail = 0;
        // this.checkVaule ='POST';
        // console.log(this.checkVaule =='POST');
        // console.log( this.countPost)
        // console.log(this.countPost%2 == 1 && this.checkVaule =='POST')

        if(this.countPost%2 == 1){
          this.$emit('input', this.selectVal)
          this.$emit('change', this.selectVal)
        //   this.list.push(this.selectVal)
        } else{
            console.log("quxiao")
          
            this.$emit('input', '')
            this.$emit('change', '')
         
          
        }
        
        
      } else if(label == 'EMAIL' ) {
        this.selectVal = label
        this.countEmail = this.countEmail + 1;
        this.countPost = 0;
        // this.checkVaule ='EMAIL'
        // console.log(this.checkVaule =='EMAIL');
        // console.log(this.countEmail%2 == 1 && this.checkVaule =='EMAIL')
        if(this.countEmail%2 == 1){
          this.$emit('input', this.selectVal)
          this.$emit('change', this.selectVal)
       }  else{
            console.log("quxiao")
          
            this.$emit('input', '')
            this.$emit('change', '')
         
          
        }
      }
      // if(!this.value||(this.value == 'INDIVIDUAL'&&this.label == 'CORPORATE')||(this.value == 'CORPORATE'&&this.label == 'INDIVIDUAL')){
      //   console.log('123')
      //   this.selectVal = this.label
      //   this.both = true;
      //   this.$emit('input', this.selectVal)
      //   this.$emit('change', this.selectVal)
      // }else{console.log(456);
      //   this.both = false;
      //   this.$emit('input', '')
      //   this.$emit('change', '')
      // }
      // if(this.value){
      //   console.log(444);
      //   this.both = false;
      //   this.$emit('input', '')
      //   this.$emit('change', '')
      // }

      // if(this.value == '1') {
      //   this.$emit('input', '')
      //   this.$emit('change', '')
      // }
      
    },
    keydown (e) {
      if (e.keyCode == 32 || e.keyCode == 13) {
        this.click()
      }
    },
  },
  mounted () {
    this.selectVal = this.value
    console.log("mounted")

    if(this.value=='POST' && this.label == 'POST') {
      console.log(this.value);
      this.countPost = 1;
      // this.checkVaule = 'POST';
      // console.log(this.countEmail%2 == 1 && this.countPost%2 == 0);
      // console.log(this.countEmail%2 == 0 && this.countPost%2 == 1);
    } else if(this.value=='EMAIL' && this.label == 'EMAIL') {
      console.log(this.value);
      this.countEmail = 1;
      // this.checkVaule = 'EMAIL';
      // console.log(this.countEmail%2 == 1 && this.countPost%2 == 0);
      // console.log(this.countEmail%2 == 0 && this.countPost%2 == 1);
    } else if(this.value=='BOTH') {
       this.countPost = 1;
       this.countEmail = 1;
    } 

    console.log(this.value)
    console.log(this.label)
  }
}
</script>

<style lang="scss" scoped>
// 樣式是HkRadio.scss, 在all.scss中引入
@media (max-width: 767px) {
  .ms-checkBox {
    margin-right: 0 !important;
  }

  .ms-checkBox .hk-checkbox {
    width: 1.7rem !important;
  }
}

input[type=checkbox]:checked:after {
         content: "";
         background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/HkCheckbox.vue